module.exports = __webpack_public_path__ + "static/media/yakuza-picture-1.be88cff1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Yakuza/yakuza-picture-1.jpg
// module id = 615
// module chunks = 0 1 2 3 4 14